"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthTypes = void 0;
// Auth types supported at tubi
exports.AuthTypes = ['AMAZON', 'UNKNOWN', 'NOT_AUTHED', 'EMAIL', 'FACEBOOK', 'CODE', 'GOOGLE', 'MOBILE_APP'];
//# sourceMappingURL=baseTypes.js.map